import styled from "styled-components";
import { spacingExtender } from "ui-components";

const CommentWrapper = styled.div`
  ${() => spacingExtender({ padding: "3" })}
`;

export { CommentWrapper };



// WEBPACK FOOTER //
// ./src/common/components/Comment/styled.js